export enum EPrinciple {
  FOSTER_EQUITY = 'Foster Equity',
  INNOVATE_FOR_ALL = 'Innovate for All',
  PRIORITISE = 'Prioritise Environment and Society',
  DEMOCRATISE = 'Democratise',
}
